(() => {
  'use strict';

  const node = document.getElementById('CTOClarity');
  const project = node?.dataset.projectId;
  if (!/^[a-z0-9]{6,32}$/i.test(project || '') || window.CTOClarityInitialized) return;
  const privatePath = /\/(?:account|accounts|cart|checkouts?|orders)(?:\/|$)|\/pages\/(?:saisir-passeports|retour-experience|suivi[^/]*|client-questionnaire|demander-un-devis)(?:\/|$)/i;
  const safeParams = /^(?:utm_(?:source|medium|campaign|content|term)|variant|preview_theme_id|_fd|pb|view|cto_test|gclid|gbraid|wbraid|fbclid)$/;
  if (privatePath.test(location.pathname) || window.Shopify?.designMode) return;
  if ([...new URLSearchParams(location.search)].some(([key, value]) => !safeParams.test(key) || value.includes('@'))) return;
  window.CTOClarityInitialized = true;

  let started = false;
  const update = () => {
    const privacy = window.Shopify?.customerPrivacy;
    const analytics = privacy?.analyticsProcessingAllowed?.() === true;
    if (!analytics && !started) return;
    if (!started) {
      started = true;
      document.body.setAttribute('data-clarity-mask', 'true');
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    }
    window.clarity('consentv2', {
      analytics_Storage: analytics ? 'granted' : 'denied',
      ad_Storage: analytics && privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() === true ? 'granted' : 'denied'
    });
    if (!document.getElementById('CTOClarityTag')) {
      const script = document.createElement('script');
      script.id = 'CTOClarityTag';
      script.src = 'https://www.clarity.ms/tag/' + project;
      script.async = true;
      document.head.appendChild(script);
    }
  };
  document.addEventListener('visitorConsentCollected', update);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) update(); });
  } else update();
})();
